












import { defineComponent } from "@nuxtjs/composition-api";
import LazyComponent from "v-lazy-component/vue2";
import SkeletonPlaceholder from "~/components/SkeletonPlaceholder.vue";
import ProductsOnOff from "~/components/homePage/promotionOnOff/ProductsOnOff.vue";
export default defineComponent({
  name: "PromotionOnOff",
  components: {
    SkeletonPlaceholder,
    LazyComponent,
    ProductsOnOff,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
  },

  setup() {},
});
